import React, { useEffect, useState } from "react";
import styles from "./backCurtain.module.css";

const BackCurtain = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(true);
  }, []);

  return (
    <div
      className={`${styles.back_curtain} ${
        isActive && styles.back_curtain_active
      }`}
    ></div>
  );
};

export default BackCurtain;
